var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getSubmitState)?_c('div',{staticClass:"success"},[_c('Header'),_c('h1',{staticClass:"text-center",domProps:{"innerHTML":_vm._s(_vm.getSubmitState.msg)}}),_c('Footer')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }